import React, {  useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';

export interface SubMenuItem {
  id: string;
  title: string;
  icon: any;
  path: string;
  visible?: boolean;
}

interface NavbarProps {
  subMenuItems: SubMenuItem[];
}

const Navbar: React.FC<NavbarProps> = ({ subMenuItems }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleNavigation = useCallback((path: string) => {
    navigate(path);
  }, [navigate]);

  const isActive = useCallback((path: string) => {
    return location.pathname.includes(path);
  }, [location.pathname]);

  return (
    <ContentHeader>
      <BottomLine />
      <TabsContainer>
        {subMenuItems.map((subItem) => (
          <NavItem key={subItem.id} active={isActive(subItem.path)}>
            <TabButton
              onClick={() => handleNavigation(subItem.path)}
              active={isActive(subItem.path)}
            >
              {subItem.title}
            </TabButton>
          </NavItem>
        ))}
      </TabsContainer>
    </ContentHeader>
  )
};

export default React.memo(Navbar);

const ContentHeader = styled.div`
  background-color: transparent;
  margin-top: 30px;
  padding: 0;
  position: relative;
  width: 100%;
`;

const BottomLine = styled.div`
  position: absolute;
  height: 1px;
  background-color: #dee2e6;
  bottom: 0;
  left: 0;
  right: 0;
`;

const TabsContainer = styled.div`
  display: flex;
  position: relative;
  z-index: 1;
  padding-left: 0;
  flex-wrap: wrap;
  width: 100%;
`;

const TabButton = styled.button<{active: boolean}>`
  margin-right: 0;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 12px 5px 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.active ? '#1E4AB7' : '#1d192c'};
  white-space: nowrap;
`;

const NavItem = styled.div<{active: boolean}>`
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-right: 0;
  position: relative;
  border-bottom: ${props => props.active ? '2px solid #1E4AB7' : '2px solid transparent'};
  margin-bottom: -1px;

  &:hover {
    color: #1E4AB7;
    border-bottom: 2px solid #1E4AB7;
  }
`; 